import { api } from 'shared/api'

import {
  CreateTriggerRuleSchema,
  SetTitleSchema,
  DeleteTriggerRuleSchema,
  ListTriggerRulesSchema,
  ChangeStatusSchema,
  RestoreTriggerRuleSchema,
  UpdateTriggerRuleSchema,
  GetTriggerRuleSchema,
  CopyTriggerRuleSchema,
} from './schemas'

export const TriggerRulesApi = {
  create: api.account.createPost({
    url: 'triggerRule/create',
    schemas: CreateTriggerRuleSchema,
  }),
  setTitle: api.account.createPost({
    url: 'triggerRule/setTitle',
    schemas: SetTitleSchema,
  }),
  delete: api.account.createPost({
    url: 'triggerRule/delete',
    schemas: DeleteTriggerRuleSchema,
  }),
  list: api.account.createGet({
    url: 'triggerRule/list',
    schemas: ListTriggerRulesSchema,
  }),
  changeStatus: api.account.createPost({
    url: 'triggerRule/changeStatus',
    schemas: ChangeStatusSchema,
  }),
  restore: api.account.createPost({
    url: 'triggerRule/restore',
    schemas: RestoreTriggerRuleSchema,
  }),
  update: api.account.createPost({
    url: 'triggerRule/update',
    schemas: UpdateTriggerRuleSchema,
  }),
  copy: api.account.createPost({
    url: 'triggerRule/copy',
    schemas: CopyTriggerRuleSchema,
  }),
  get: api.account.createGet({
    url: 'triggerRule/get',
    schemas: GetTriggerRuleSchema,
  }),
}
